// extracted by mini-css-extract-plugin
export default {"btn":"secondaryButton_btn__7hQ4na7Q","default":"secondaryButton_default__UwbYmqL0","active":"secondaryButton_active__wpcj7TzW"};